







import { Component, Vue, Prop } from 'vue-property-decorator';
import { IIssueType } from '@/lib/interfaces';

@Component
export default class IssueTypeOption extends Vue {
  @Prop() private option!: IIssueType;
}
